// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* it don't matter if you're black or white... */
/* DEPRECATED: need to update theme to use \$brand-palette instead of this */
.success {
  color: #4caf50;
}

.error {
  color: #f44336;
}

.brand {
  color: #004a7c;
}

.brand-shade {
  color: #003254;
}

.gray {
  color: #777;
}

.gray-shade {
  color: #373737;
}

.success-inv {
  background-color: #4caf50;
  color: white;
}

.error-inv {
  background-color: #f44336;
  color: white;
}

.gray-shade-inv {
  background-color: #373737;
  color: white;
}

.gray-light-tint-back {
  background-color: #f7f7f7;
}

mat-card.mat-mdc-card {
  padding: 16px;
  margin: 50px 0;
}
mat-card.mat-mdc-card mat-card-header.mat-mdc-card-header {
  flex-direction: column;
}
mat-card.mat-mdc-card mat-card-header.mat-mdc-card-header .mat-card-header-text {
  display: flex;
  flex-flow: row nowrap;
  margin-left: 0;
  margin-right: 3px;
}
mat-card.mat-mdc-card mat-card-header.mat-mdc-card-header .mat-card-header-text mat-card-title.mat-mdc-card-title {
  color: #ffe082;
  padding: 0 14px 0 15px;
  position: relative;
}
mat-card.mat-mdc-card mat-card-header.mat-mdc-card-header .mat-card-header-text mat-card-title.mat-mdc-card-title:before {
  background: #ffe082;
  border-radius: 50%;
  content: "";
  height: 10px;
  left: 0;
  position: absolute;
  top: 5px;
  width: 10px;
}
mat-card.mat-mdc-card mat-card-header.mat-mdc-card-header .mat-card-header-text mat-card-title.mat-mdc-card-title:after {
  background: #c7c8ca;
  border-radius: 50%;
  content: "";
  height: 5px;
  right: 2px;
  position: absolute;
  top: 8px;
  width: 5px;
}
mat-card.mat-mdc-card mat-card-header.mat-mdc-card-header .mat-card-header-text mat-card-subtitle.mat-mdc-card-subtitle {
  margin-left: 3px;
  margin-top: 0;
}
mat-card.mat-mdc-card mat-card-content.mat-mdc-card-content h3 {
  color: #000;
  font-size: 15px;
}
mat-card.mat-mdc-card mat-card-content.mat-mdc-card-content p {
  color: #c7c8ca;
}
mat-card.mat-mdc-card mat-card-actions.mat-mdc-card-actions {
  background-color: #f7f7f7;
}
mat-card.mat-mdc-card mat-card-actions.mat-mdc-card-actions, mat-card.mat-mdc-card mat-card-actions.mat-mdc-card-actions:last-child {
  padding: 6px 8px 8px !important;
}
mat-card.mat-mdc-card mat-card-actions.mat-mdc-card-actions .mat-mdc-button {
  color: #f44336;
}`, "",{"version":3,"sources":["webpack://./src/theme/colors.scss","webpack://./src/app/shared/components/recent-update-card/recent-update-card.component.scss"],"names":[],"mappings":"AAAA,gDAAA;AA8GA,2EAAA;AAcA;EACE,cA5FQ;AC7BV;;AD4HA;EACE,cApEM;ACrDR;;AD4HA;EACE,cAhIM;ACOR;;AD4HA;EACE,cAnIY;ACUd;;AD4HA;EACE,WAjEK;ACxDP;;AD4HA;EACE,cAnEW;ACtDb;;AD4HA;EACE,yBApHQ;EAqHR,YAAA;ACzHF;;AD4HA;EACE,yBA7FM;EA8FN,YAAA;ACzHF;;AD4HA;EACE,yBAjFW;EAkFX,YAAA;ACzHF;;AD4HA;EACE,yBAxEgB;ACjDlB;;AAzCA;EACE,aAAA;EACA,cAAA;AA4CF;AA3CE;EACE,sBAAA;AA6CJ;AA3CI;EACE,aAAA;EACA,qBAAA;EACA,cAAA;EACA,iBAAA;AA6CN;AA3CM;EACE,cDgCE;EC/BF,sBAAA;EACA,kBAAA;AA6CR;AA3CQ;EACE,mBD2BA;EC1BA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;AA6CV;AA1CQ;EACE,mBD2CE;EC1CF,kBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AA4CV;AAxCM;EACE,gBAAA;EACA,aAAA;AA0CR;AApCI;EACE,WDlDE;ECmDF,eAAA;AAsCN;AAnCI;EACE,cDkBM;ACmBZ;AAjCE;EACE,yBD+Bc;ACIlB;AAjCI;EAEE,+BAAA;AAkCN;AA/BI;EACE,cDRE;ACyCR","sourcesContent":["/* it don't matter if you're black or white... */\n$black: #000;\n$white: #fff;\n\n$brand-tint: #1890e2;\n$brand: #004a7c;\n$brand-shade: #003254;\n$brand-palette: (\n  300: $brand-tint,\n  400: $brand,\n  500: $brand-shade,\n  contrast: (\n    300: $black,\n    400: $white,\n    500: $white,\n  ),\n);\n\n$brand-light-tint: #a6e0f7;\n$brand-light: #00adef;\n$brand-light-shade: #006e98;\n$brand-light-palette: (\n  300: $brand-light-tint,\n  400: $brand-light,\n  500: $brand-light-shade,\n  contrast: (\n    300: $black,\n    400: $white,\n    500: $white,\n  ),\n);\n\n$success-tint: #c8e6c9;\n$success: #4caf50;\n$success-shade: #2e7d32;\n$success-palette: (\n  300: $success-tint,\n  400: $success,\n  500: $success-shade,\n  contrast: (\n    300: $black,\n    400: $white,\n    500: $white,\n  ),\n);\n\n$warning-tint: #ffc107;\n$warning: #ffe082;\n$warning-shade: #ff8f00;\n$warning-palette: (\n  300: $warning-tint,\n  400: $warning,\n  500: $warning-shade,\n  contrast: (\n    300: $black,\n    400: $white,\n    500: $white,\n  ),\n);\n\n$error-tint: #ffcdd2;\n$error: #f44336;\n$error-shade: #c62828;\n$error-palette: (\n  300: $error-tint,\n  400: $error,\n  500: $error-shade,\n  contrast: (\n    300: $black,\n    400: $white,\n    500: $white,\n  ),\n);\n\n$gray-tint: #c7c8ca;\n$grey-tint: $gray-tint;\n$gray: #777;\n$grey: $gray;\n$gray-shade: #373737;\n$grey-shade: $gray-shade;\n$gray-palette: (\n  300: $gray-tint,\n  400: $gray,\n  500: $gray-shade,\n  contrast: (\n    300: $black,\n    400: $white,\n    500: $white,\n  ),\n);\n$grey-palette: $gray-palette;\n\n$gray-light-tint: #f7f7f7;\n$grey-light-tint: $gray-light-tint;\n$gray-light: #e0e0e0;\n$grey-light: $gray-light;\n$gray-light-shade: #c4c4c4;\n$grey-light-shade: $gray-light-shade;\n$gray-light-palette: (\n  300: $gray-light-tint,\n  400: $gray-light,\n  500: $gray-light-shade,\n  contrast: (\n    300: $black,\n    400: $black,\n    500: $black,\n  ),\n);\n$grey-light-palette: $gray-light-palette;\n\n/* DEPRECATED: need to update theme to use $brand-palette instead of this */\n$rs-blue-pal: (\n  300: $brand-light,\n  400: $brand-tint,\n  500: $brand,\n  600: $brand-shade,\n  contrast: (\n    300: $white,\n    400: $black,\n    500: $white,\n    600: $white,\n  ),\n);\n\n.success {\n  color: $success;\n}\n\n.error {\n  color: $error;\n}\n\n.brand {\n  color: $brand;\n}\n\n.brand-shade {\n  color: $brand-shade;\n}\n\n.gray {\n  color: $gray;\n}\n\n.gray-shade {\n  color: $gray-shade;\n}\n\n.success-inv {\n  background-color: $success;\n  color: white;\n}\n\n.error-inv {\n  background-color: $error;\n  color: white;\n}\n\n.gray-shade-inv {\n  background-color: $gray-shade;\n  color: white;\n}\n\n.gray-light-tint-back {\n  background-color: $gray-light-tint;\n}\n","@import \"../../../../theme/colors.scss\";\n\nmat-card.mat-mdc-card {\n  padding: 16px;\n  margin: 50px 0;\n  mat-card-header.mat-mdc-card-header {\n    flex-direction: column;\n\n    .mat-card-header-text {\n      display: flex;\n      flex-flow: row nowrap;\n      margin-left: 0;\n      margin-right: 3px;\n\n      mat-card-title.mat-mdc-card-title {\n        color: $warning;\n        padding: 0 14px 0 15px;\n        position: relative;\n\n        &:before {\n          background: $warning;\n          border-radius: 50%;\n          content: \"\";\n          height: 10px;\n          left: 0;\n          position: absolute;\n          top: 5px;\n          width: 10px;\n        }\n\n        &:after {\n          background: $gray-tint;\n          border-radius: 50%;\n          content: \"\";\n          height: 5px;\n          right: 2px;\n          position: absolute;\n          top: 8px;\n          width: 5px;\n        }\n      }\n      \n      mat-card-subtitle.mat-mdc-card-subtitle {\n        margin-left: 3px;\n        margin-top: 0;\n      }\n    }\n  }\n  \n  mat-card-content.mat-mdc-card-content {\n    h3 {\n      color: $black;\n      font-size: 15px;\n    }\n\n    p {\n      color: $gray-tint;\n    }\n  }\n  \n  mat-card-actions.mat-mdc-card-actions {\n    background-color: $gray-light-tint;\n\n    &,\n    &:last-child {\n      padding: 6px 8px 8px !important;\n    }\n\n    .mat-mdc-button {\n      color: $error;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
